<template>
<header class="d-flex justify-content-between align-items-center">
    <label for="toggle-1" class="toggle-menu" @click="toggleMenu">
        <ul>
            <li></li>
            <li></li>
            <li></li>
        </ul>
    </label>
    <!-- <strong @click="toggleMenu"> &#9776;	</strong> -->
    <nav class="nav_center" style="padding: 0" :style="{ display: isMenuVisible ? 'block' : 'none' }">
        <ul style="list-style: none">
            <li :class="{ topmenuactive: activeTab === 'lienhe' }" @click="changeTab('lienhe')">
                <a id="urlBai3" href="chuongtrinhtaitroxathidiem#chuongtrinhtaitro/"> {{ currentLanguage.header_text_xaThidiem }}</a>
            </li>
            <li :class="{ topmenuactive: activeTab === 'hethongcntt' }" @click="changeTab('hethongcntt')">
                <a id="urlHethongcntt" href="chuongtrinhtaitroxathidiem#hethongcntt/">{{ currentLanguage.header_text_hethongCNTT15xa }}</a>
            </li>
            <li :class="{ topmenuactive: activeTab === 'yte' }" @click="changeTab('yte')">
                <a id="urlYte" href="chuongtrinhtaitroxathidiem#thoathuantaitro/">{{ currentLanguage.header_text_theDaNang_ctTaiTro1  }}</a>
            </li>
             <li :class="{ topmenuactive: activeTab === 'Quangtri' }" @click="changeTab('Quangtri')">
                <a id="urlBai2" href="chuongtrinhtaitroxathidiem#quangtri/">{{ currentLanguage.header_text_QuangTri  }}</a>
            </li>
            <li :class="{ topmenuactive: activeTab === 'danang' }" @click="changeTab('danang')">
                <a id="urlDanang" href="chuongtrinhtaitroxathidiem#chuongtrinhtaitro/"> {{ currentLanguage.header_text_DaNang }} </a>
            </li>
            <li :class="{ topmenuactive: activeTab === 'giaoduc' }" @click="changeTab('giaoduc')">
                <a id="urlGiaoDuc" href="chuongtrinhtaitroxathidiem#hanoi/"> {{ currentLanguage.header_text_Hanoi }}</a>
            </li>
             <li :class="{ topmenuactive: activeTab === 'Haiphong' }" @click="changeTab('Haiphong')">
                <a id="urlBai1" href="chuongtrinhtaitroxathidiem#haiphong/"> {{ currentLanguage.header_text_HaiPhong }}</a>
            </li>
              <li :class="{ topmenuactive: activeTab === 'HoChiMinh' }" @click="changeTab('HoChiMinh')">
                <a id="urlHoChiMinh" href="chuongtrinhtaitroxathidiem#hochiminh/">{{ currentLanguage.header_text_HoChiMinh }}</a>
            </li>

            <li :class="{ topmenuactive: activeTab === 'cantho' }" @click="changeTab('cantho')">
                <a id="urlCantho" href="chuongtrinhtaitroxathidiem#cantho/">{{ currentLanguage.header_text_CanTho }}</a>
            </li>
          
          

            <li :class="{ topmenuactive: activeTab === 'HungYen' }" @click="changeTab('HungYen')">
                <a id="urlHungYen" href="chuongtrinhtaitroxathidiem#hungyen/">{{ currentLanguage.header_text_Hungyen  }}</a>
            </li>
            <li :class="{ topmenuactive: activeTab === 'NinhBinh' }" @click="changeTab('NinhBinh')">
                <a id="urlNinhBinh" href="chuongtrinhtaitroxathidiem#ninhbinh/">{{ currentLanguage.header_text_NinhBinh }}</a>
            </li>

            <li :class="{ topmenuactive: activeTab === 'BacNinh' }" @click="changeTab('BacNinh')">
                <a id="urlBacNinh" href="chuongtrinhtaitroxathidiem#bacninh/">{{currentLanguage.header_text_BacNinh }}</a>
            </li>

            <li :class="{ topmenuactive: activeTab === 'ThaiNguyen' }" @click="changeTab('ThaiNguyen')">
                <a id="urlThaiNguyen" href="chuongtrinhtaitroxathidiem#thainguyen/">{{currentLanguage.header_text_ThaiNguyen }}</a>
            </li>
        </ul>
    </nav>
    <div class="menu_right" style="display: flex">
        <div class="menu_co_right" style="display: flex">
            <a @click="changeLanguage('vi')" class="lang" style="padding: 5px"><img src="img/img-item-vimass-2022/co/vi-VN.gif" />
            </a>
            <a @click="changeLanguage('en')" class="lang" style="padding: 5px"><img style="width: 25px" src="img/img-item-vimass-2022/co/us.png" />
            </a>
            <a @click="changeLanguage('cn')" class="lang d-none" style="padding: 5px"><img style="width: 25px" src="img/img-item-vimass-2022/co/cn.jpg" />
            </a>
            <a @click="changeLanguage('kr')" class="lang d-none" style="padding: 5px"><img style="width: 25px" src="img/img-item-vimass-2022/co/kr.jpg" />
            </a>
            <a @click="changeLanguage('ja')" class="lang d-none" style="padding: 5px">
                <img style="width: 25px" src="img/img-item-vimass-2022/co/ja.jpg" />
            </a>

            <span class="clickShow" style="color: #303038; cursor: pointer; margin: auto"><i class="fa fa-ellipsis-h" aria-hidden="true"></i></span>
        </div>
        <a id="urlHome" href="/" style="margin: 0 10px"><img style="width: 35px; height: 35px" src="img/home-icon-white-8.jpg" />
        </a>
    </div>
</header>
<div class="wrapper row3">
    <main class="hoc container-fluid clear bv">
        <!-- haiphong-->

        <div id="hethongcntt" v-if="showHethongcntt" style="min-height: 500px">
            <!-- <MainDinhDanhXacThuc></MainDinhDanhXacThuc> -->
            <div class="title-bai-viet" v-html="titleHethongcntt"></div>
            <div v-html="contentHethongcntt"></div>
        </div>

        <div id="yte" v-if="showYte" style="min-height: 500px">
            <!-- <div class="title-bai-viet" v-html="titleYte"></div>
            <div v-html="contentYte"></div> -->
            <ThoaThuanTaiTro></ThoaThuanTaiTro>
        </div>
        <div id="danang" v-if="showDanang" style="min-height: 500px">
            <!-- <div class="title-bai-viet" v-html="titleDanang"></div>
        <div v-html="contentDanang"></div> -->
            <DaNang></DaNang>
        </div>
        <div id="giaoduc" v-if="showGiaoDuc" style="min-height: 500px">
            <!-- <div class="title-bai-viet" v-html="titleGiaoDuc"></div>
            <div v-html="contentGiaoDuc"></div> -->
            <HaNoi></HaNoi>
        </div>

        <div id="Haiphong" v-if="showHaiphong" style="min-height: 500px">
            <!-- <div class="title-bai-viet" v-html="titleHaiphong"></div>
        <div v-html="contentHaiphong"></div> -->
            <HaiPhong></HaiPhong>
        </div>
        <!-- Quangtri -->
        <div id="Quangtri" v-if="showQuangtri" style="min-height: 500px; background-image: none !important">
            <!-- <div class="title-bai-viet" v-html="titleQuangtri"></div>
        <div v-html="contentQuangtri"></div> -->
            <QuangTri></QuangTri>
        </div>

        <!-- LIEN HE -->
        <div id="lienhe" v-if="showLienHe" style="min-height: 500px; background-image: none !important">
            <div class="title-bai-viet" v-html="titleLienHe"></div>
            <div v-html="contentLienHe"></div>
            <!-- <LinhVuc></LinhVuc> -->
        </div>

        <div id="cantho" v-if="showCantho" style="min-height: 500px; background-image: none !important">
            <!-- <div class="title-bai-viet" v-html="titleCantho"></div>
            <div v-html="contentCantho"></div> -->
            <CanTho></CanTho>
        </div>

        <div id="HoChiMinh" v-if="showHoChiMinh" style="min-height: 500px; background-image: none !important">
            <HoChiMinh></HoChiMinh>
        </div>
        <div id="HungYen" v-if="showHungYen" style="min-height: 500px; background-image: none !important">
            <HungYen></HungYen>
        </div>
        <div id="NinhBinh" v-if="showNinhBinh" style="min-height: 500px; background-image: none !important">
            <NinhBinh></NinhBinh>
        </div>
        <div id="BacNinh" v-if="showBacNinh" style="min-height: 500px; background-image: none !important">
            <BacNinh></BacNinh>
        </div>
        <div id="ThaiNguyen" v-if="showThaiNguyen" style="min-height: 500px; background-image: none !important">
            <ThaiNguyen></ThaiNguyen>
        </div>
    </main>
</div>
<FooterView></FooterView>
</template>

<script>
import FooterView from "@/views/Vimass/Footer/FooterView.vue";
import {
    languages
} from "@/components/languages";
import {
    apiChiTietBaiViet
} from "@/components/listService";
import axios from "axios";
import DaNang from "../MainBaiVietCon/GiaoDucVaYte/DaNang.vue";
import QuangTri from "../MainBaiVietCon/GiaoDucVaYte/QuangTri.vue";
import HaiPhong from "../MainBaiVietCon/GiaoDucVaYte/HaiPhong.vue";
import LinhVuc from "../MainBaiVietCon/GiaoDucVaYte/6LinhVuc.vue";

import MainDinhDanhXacThuc from "./MainDinhDanhXacThuc.vue";
import CanTho from "../MainBaiVietCon/GiaoDucVaYte/CanTho.vue";
import HaNoi from "../MainBaiVietCon/GiaoDucVaYte/HaNoi.vue";
import HoChiMinh from "../MainBaiVietCon/GiaoDucVaYte/HoChiMinh.vue";
import HungYen from "../MainBaiVietCon/GiaoDucVaYte/HungYen.vue";
import NinhBinh from "../MainBaiVietCon/GiaoDucVaYte/NinhBinh.vue";
import BacNinh from "../MainBaiVietCon/GiaoDucVaYte/BacNinh.vue";
import ThaiNguyen from "../MainBaiVietCon/GiaoDucVaYte/ThaiNguyen.vue";
import ThoaThuanTaiTro from "../MainBaiVietCon/GiaoDucVaYte/ThoaThuanTaiTro.vue";

// import { is } from "core-js/core/object";
// import { is } from "core-js/core/object";
// import { content } from "html2canvas/dist/types/css/property-descriptors/content";

export default {
    components: {
        FooterView,
        // eslint-disable-next-line vue/no-unused-components
        MainDinhDanhXacThuc,
        DaNang,
        QuangTri,
        CanTho,
        HaiPhong,ThoaThuanTaiTro,
        HaNoi,
        HoChiMinh,
        HungYen,
        NinhBinh,
        BacNinh,
        ThaiNguyen,
        
        // eslint-disable-next-line vue/no-unused-components
        LinhVuc
    },
    data() {
        return {
            activeTab: "lienhe",
            isMenuVisible: false,

            currentLanguage: languages.vi,
            lang: "",
            base64: "",
            base64Title: "",
            showYte: false,
            showHaiphong: false,
            showHethongcntt: false,
            showQuangtri: false,
            showLienHe: true,
            showCantho: false,
            showGiaoDuc: false,
            showDanang: false,

            //active tab
            // isActiveGioiThieu: true,isActiveYte:true, isActiveGiaoDuc:false,

            isActiveYte: false,
            isActiveHaiphong: false,
            isActiveQuangtri: false,
            isActiveHethongcntt: false,
            isActiveLienHe: true,
            isActiveCantho: false,
            isActiveGiaoDuc: false,
            isActiveDanang: false,
            isActiveHoChiMinh: false,
            isActiveHungYen: false,
            isActiveNinhBinh: false,
            showHoChiMinh: false,
            showHungYen: false,
            showNinhBinh: false,
            showBacNinh: false,
            showThaiNguyen: false,

            //title
            titleGioiThieu: "",
            titleYte: "",
            titleHethongcntt: "",
            titleHaiphong: "",
            titleQuangtri: "",
            titleLienHe: "",
            titleCantho: "",
            titleGiaoDuc: "",
            titleDanang: "",

            //content
            contentGioiThieu: "",
            contentHethongcntt: "",
            contentHaiphong: "",
            contentQuangtri: "",
            contentYte: "",
            contentLienHe: "",
            contentCantho: "",
            contentDanang: "",
            contentGiaoDuc: "",
            hasMounted: false,
            langId: "1",
        };
    },
    mounted() {
        if (window.innerWidth <= 768) {
            this.isMenuVisible = false;
        } else {
            this.isMenuVisible = true;
        }
        if (!this.hasMounted) {
            this.hasMounted = true; // Set the flag to true to indicate that mounted has been executed
            const path = window.location.pathname // '/en/thanhtoanthongminh'
            this.lang = (path.split('/').filter(Boolean)[0] || 'vi').slice(0, 2)
            if (this.lang == "vi") {
                document.title = "Vimass.vn - Chương trình tài trợ 20 xã thí điểm";
            } else if (this.lang == "en") {
                document.title = "Vimass.vn - Sponsorship program for 20 pilot communes";
            } else if (this.lang == "cn") {
                document.title = "Vimass.vn - 交通及公共服务";
            } else if (this.lang == "kr") {
                document.title = "Vimass.vn - 교통 및 공공 서비스";
            }

            // this.performPostRequest("173621689676614s2C", "lienhe", this.lang);
            // window.location.href = this.lang + "/chuongtrinhtaitroxathidiem#yte/";

            document.getElementById("urlHome").setAttribute("href", this.lang);
            document.getElementById("urlYte").setAttribute(
                "href",
                this.lang + "/chuongtrinhtaitroxathidiem#thoathuantaitro/"
            );
            document
                .getElementById("urlBai1")
                .setAttribute(
                    "href",
                    this.lang + "/chuongtrinhtaitroxathidiem#haiphong/"
                );
            document
                .getElementById("urlBai2")
                .setAttribute(
                    "href",
                    this.lang + "/chuongtrinhtaitroxathidiem#quangtri/"
                );
            document
                .getElementById("urlBai3")
                .setAttribute(
                    "href",
                    this.lang + "/chuongtrinhtaitroxathidiem#chuongtrinhtaitro/"
                );
            document
                .getElementById("urlHethongcntt")
                .setAttribute(
                    "href",
                    this.lang + "/chuongtrinhtaitroxathidiem#hethongcntt/"
                );
            document
                .getElementById("urlCantho")
                .setAttribute(
                    "href",
                    this.lang + "/chuongtrinhtaitroxathidiem#cantho/"
                );
            document
                .getElementById("urlGiaoDuc")
                .setAttribute(
                    "href",
                    this.lang + "/chuongtrinhtaitroxathidiem#hanoi/"
                );
            document
                .getElementById("urlDanang")
                .setAttribute(
                    "href",
                    this.lang + "/chuongtrinhtaitroxathidiem#danang/"
                );
            document
                .getElementById("urlHoChiMinh")
                .setAttribute(
                    "href",
                    this.lang + "/chuongtrinhtaitroxathidiem#hochiminh/"
                );
            document
                .getElementById("urlHungYen")
                .setAttribute(
                    "href",
                    this.lang + "/chuongtrinhtaitroxathidiem#hungyen/"
                );
            document
                .getElementById("urlNinhBinh")
                .setAttribute(
                    "href",
                    this.lang + "/chuongtrinhtaitroxathidiem#ninhbinh/"
                );
            document
                .getElementById("urlBacNinh")
                .setAttribute(
                    "href",
                    this.lang + "/chuongtrinhtaitroxathidiem#bacninh/"
                );
            document
                .getElementById("urlThaiNguyen")
                .setAttribute(
                    "href",
                    this.lang + "/chuongtrinhtaitroxathidiem#thainguyen/"
                );

            const hash = window.location.hash;
            if (hash && hash.includes("#chuongtrinhtaitro")) {
                this.changeTab("lienhe");
            } else if (hash && hash.includes("#hethongcntt")) {
                this.changeTab("hethongcntt");
            } else if (hash && hash.includes("#thoathuantaitro")) {
                this.changeTab("yte");
            } else if (hash && hash.includes("#haiphong")) {
                // this.changeTab("taitro");
                this.changeTab("Haiphong");
            } else if (hash && hash.includes("#quangtri")) {
                this.changeTab("Quangtri");
            } else if (hash && hash.includes("#cantho")) {
                this.changeTab("cantho");
            } else if (hash && hash.includes("#hanoi")) {
                this.changeTab("giaoduc");
            } else if (hash && hash.includes("#danang")) {
                this.changeTab("danang");
            } else if (hash && hash.includes("#hochiminh")) {
                this.changeTab("HoChiMinh");
            } else if (hash && hash.includes("#hungyen")) {
                this.changeTab("HungYen");
            } else if (hash && hash.includes("#ninhbinh")) {
                this.changeTab("NinhBinh");
            } else if (hash && hash.includes("#bacninh")) {
                this.changeTab("BacNinh");
            } else if (hash && hash.includes("#thainguyen")) {
                this.changeTab("ThaiNguyen");
            } else {
                this.changeTab("lienhe");
            }
        }
    },
    created() {
        // this.performPostlistBaiViet();
        const lang = this.$route.params.lang;
        if (languages[lang]) {
            this.currentLanguage = languages[lang];
        }
        const savedLanguage = localStorage.getItem("languages") || "vi";

        if (savedLanguage && languages[savedLanguage]) {
            this.currentLanguage = languages[savedLanguage];
        }
    },
    methods: {
        changeLanguage(lang) {
            // this.currentLanguage = languages[lang];
            // localStorage.setItem("languages", lang);
            // window.location.reload();
            console.log(" window.location.hash ", window.location.hash);
            this.currentLanguage = languages[lang];
            localStorage.setItem("languages", lang);
            const langReload = localStorage.getItem("languages");
            window.location.href = "/" + langReload + "/chuongtrinhtaitroxathidiem" + window.location.hash;
        },

        async performPostRequest(id, section) {
            // this.lang = localStorage.getItem("languages") || "vi";
            const path = window.location.pathname // '/en/thanhtoanthongminh'
            this.lang = (path.split('/').filter(Boolean)[0] || 'vi').slice(0, 2)

            if (this.lang == 'vi') {
                this.langId = '1';
            } else if (this.lang == 'en') {
                this.langId = '2';
            }
            try {
                // Thực hiện POST request
                const response = await axios.post(apiChiTietBaiViet, {
                    id: id,
                    langId: this.langId,
                });
                if (this.lang === "vi") {
                    this.base64 = response.data.result.content_vi;
                    this.base64Title = response.data.result.title_vi;
                                        console.log("this.base64Title vi", this.base64Title);

                } else if (this.lang === "en") {
                    this.base64 = response.data.result.content_en;
                    this.base64Title = response.data.result.title_en;
                    console.log("this.base64Title en", this.base64Title);
                    
                } else if (this.lang === "cn") {
                    this.base64 = response.data.result.content_cn;
                    this.base64Title = response.data.result.title_cn;
                } else if (this.lang === "kr") {
                    this.base64 = response.data.result.content_kr;
                    this.base64Title = response.data.result.title_kr;
                } else {
                    this.base64 = response.data.result.content_vi;
                    this.base64Title = response.data.result.title_vi;
                }

                var title = atob(this.base64Title);
                var decodedString = atob(this.base64);

                // Store content separately for each section
                if (section === "Haiphong") {
                    this.titleHaiphong = decodeURIComponent(escape(title));
                    this.contentHaiphong = decodeURIComponent(escape(decodedString));
                } else if (section === "Quangtri") {
                    this.titleQuangtri = decodeURIComponent(escape(title));
                    this.contentQuangtri = decodeURIComponent(escape(decodedString));
                } else if (section === "lienhe") {
                  
                    this.titleLienHe = decodeURIComponent(escape(title));
                    this.contentLienHe = decodeURIComponent(escape(decodedString));
                    
                } else if (section === "yte") {
                    this.titleYte = decodeURIComponent(escape(title));
                    this.contentYte = decodeURIComponent(escape(decodedString));
                } else if (section === "hethongcntt") {
                    this.titleHethongcntt = decodeURIComponent(escape(title));
                    this.contentHethongcntt = decodeURIComponent(escape(decodedString));
                } else if (section === "cantho") {
                    this.titleCantho = decodeURIComponent(escape(title));
                    this.contentCantho = decodeURIComponent(escape(decodedString));
                } else if (section === "danang") {
                    this.titleDanang = decodeURIComponent(escape(title));
                    this.contentDanang = decodeURIComponent(escape(decodedString));
                } else if (section === "giaoduc") {
                    this.titleGiaoDuc = decodeURIComponent(escape(title));
                    this.contentGiaoDuc = decodeURIComponent(escape(decodedString));
                }
            } catch (error) {
                console.error("Error:", error);
            }
        },
        toggleMenu() {
            this.isMenuVisible = !this.isMenuVisible;
        },
        changeTab(tab) {
            if (window.innerWidth <= 768) {
                this.isMenuVisible = false;
            }
            this.lang = localStorage.getItem("languages") || "vi";
            if (tab === "yte") {
                this.isActiveYte = true;
                this.isActiveHaiphong = false;
                this.isActiveQuangtri = false;
                this.isActiveHethongcntt = false;
                this.isActiveLienHe = false;
                this.isActiveCantho = false;
                this.isActiveGiaoDuc = false;
                this.isActiveDanang = false;
                this.isActiveHoChiMinh = false;
                this.isActiveHungYen = false;
                this.isActiveNinhBinh = false;
                this.isActiveBacNinh = false;
                this.isActiveThaiNguyen = false;
                this.performPostRequest("1755239811442fQJ18", "yte", this.lang);
            } else if (tab === "Haiphong") {
                this.isActiveYte = false;

                this.isActiveHaiphong = true;
                this.isActiveQuangtri = false;
                this.isActiveHethongcntt = false;
                this.isActiveLienHe = false;
                this.isActiveCantho = false;
                this.isActiveGiaoDuc = false;
                this.isActiveDanang = false;
                this.isActiveHoChiMinh = false;
                this.isActiveHungYen = false;
                this.isActiveNinhBinh = false;
                this.isActiveBacNinh = false;
                this.isActiveThaiNguyen = false;
                // this.performPostRequest("1694514732643ut54a", "Haiphong", this.lang);
            } else if (tab === "Quangtri") {
                this.isActiveYte = false;
                this.isActiveHaiphong = false;
                this.isActiveQuangtri = true;
                this.isActiveCantho = false;
                this.isActiveGiaoDuc = false;
                this.isActiveDanang = false;
                this.isActiveHethongcntt = false;
                this.isActiveLienHe = false;
                this.isActiveHoChiMinh = false;
                this.isActiveHungYen = false;
                this.isActiveNinhBinh = false;
                this.isActiveBacNinh = false;
                this.isActiveThaiNguyen = false;
                // this.performPostRequest("1691491192754cs1o5", "Quangtri", this.lang);
            } else if (tab === "lienhe") {
                this.isActiveYte = false;

                this.isActiveHaiphong = false;
                this.isActiveQuangtri = false;
                this.isActiveCantho = false;
                this.isActiveGiaoDuc = false;
                this.isActiveDanang = false;
                this.isActiveHethongcntt = false;
                this.isActiveLienHe = true;
                this.isActiveHoChiMinh = false;
                this.isActiveHungYen = false;
                this.isActiveNinhBinh = false;
                this.isActiveBacNinh = false;
                this.isActiveThaiNguyen = false;
                this.performPostRequest("1755078954972F3zJG", "lienhe", this.lang);
            } else if (tab === "hethongcntt") {
                this.isActiveYte = false;
                this.isActiveHaiphong = false;
                this.isActiveQuangtri = false;
                this.isActiveCantho = false;
                this.isActiveGiaoDuc = false;
                this.isActiveDanang = false;
                this.isActiveHethongcntt = true;
                this.isActiveHoChiMinh = false;
                this.isActiveHungYen = false;
                this.isActiveNinhBinh = false;
                this.isActiveBacNinh = false;
                this.isActiveThaiNguyen = false;
                this.isActiveLienHe = false;
                this.performPostRequest("1696472407793JGiel", "hethongcntt", this.lang);
            } else if (tab === "cantho") {
                this.isActiveYte = false;
                this.isActiveHaiphong = false;
                this.isActiveQuangtri = false;
                this.isActiveHethongcntt = false;
                this.isActiveLienHe = false;
                this.isActiveCantho = true;
                this.isActiveHoChiMinh = false;
                this.isActiveHungYen = false;
                this.isActiveNinhBinh = false;
                this.isActiveBacNinh = false;
                this.isActiveThaiNguyen = false;
                this.isActiveGiaoDuc = false;
                this.isActiveDanang = false;
                // this.performPostRequest("1753498567650gxUCp", "cantho", this.lang);
            } else if (tab === "giaoduc") {
                this.isActiveYte = false;
                this.isActiveHaiphong = false;
                this.isActiveQuangtri = false;
                this.isActiveHethongcntt = false;
                this.isActiveLienHe = false;
                this.isActiveCantho = false;
                this.isActiveHoChiMinh = false;
                this.isActiveHungYen = false;
                this.isActiveNinhBinh = false;
                this.isActiveBacNinh = false;
                this.isActiveThaiNguyen = false;
                this.isActiveGiaoDuc = true;
                this.isActiveDanang = false;
            } else if (tab === "danang") {
                this.isActiveYte = false;
                this.isActiveHaiphong = false;
                this.isActiveQuangtri = false;
                this.isActiveHethongcntt = false;
                this.isActiveLienHe = false;
                this.isActiveCantho = false;
                this.isActiveGiaoDuc = false;
                this.isActiveHoChiMinh = false;
                this.isActiveHungYen = false;
                this.isActiveNinhBinh = false;
                this.isActiveBacNinh = false;
                this.isActiveThaiNguyen = false;
                this.isActiveDanang = true;
                // this.performPostRequest("1749203550578RBETn", "danang", this.lang);
            } else if (tab === "HoChiMinh") {
                this.isActiveYte = false;
                this.isActiveHaiphong = false;
                this.isActiveQuangtri = false;
                this.isActiveHethongcntt = false;
                this.isActiveLienHe = false;
                this.isActiveCantho = false;
                this.isActiveGiaoDuc = false;
                this.isActiveDanang = false;
                this.isActiveHoChiMinh = true;
                this.isActiveHungYen = false;
                this.isActiveNinhBinh = false;
                this.isActiveBacNinh = false;
                this.isActiveThaiNguyen = false;
            } else if (tab === "HungYen") {
                this.isActiveYte = false;
                this.isActiveHaiphong = false;
                this.isActiveQuangtri = false;
                this.isActiveHethongcntt = false;
                this.isActiveLienHe = false;
                this.isActiveCantho = false;
                this.isActiveGiaoDuc = false;
                this.isActiveDanang = false;
                this.isActiveHoChiMinh = false;
                this.isActiveHungYen = true;
                this.isActiveNinhBinh = false;
                this.isActiveBacNinh = false;
                this.isActiveThaiNguyen = false;
            } else if (tab === "NinhBinh") {
                this.isActiveYte = false;
                this.isActiveHaiphong = false;
                this.isActiveQuangtri = false;
                this.isActiveHethongcntt = false;
                this.isActiveLienHe = false;
                this.isActiveCantho = false;
                this.isActiveGiaoDuc = false;
                this.isActiveDanang = false;
                this.isActiveHoChiMinh = false;
                this.isActiveHungYen = false;
                this.isActiveNinhBinh = true;
                this.isActiveBacNinh = false;
                this.isActiveThaiNguyen = false;
            } else if (tab === "BacNinh") {
                this.isActiveYte = false;
                this.isActiveHaiphong = false;
                this.isActiveQuangtri = false;
                this.isActiveHethongcntt = false;
                this.isActiveLienHe = false;
                this.isActiveCantho = false;
                this.isActiveGiaoDuc = false;
                this.isActiveDanang = false;
                this.isActiveHoChiMinh = false;
                this.isActiveHungYen = false;
                this.isActiveNinhBinh = false;
                this.isActiveBacNinh = true;
                this.isActiveThaiNguyen = false;
            } else if (tab === "ThaiNguyen") {
                this.isActiveYte = false;
                this.isActiveHaiphong = false;
                this.isActiveQuangtri = false;
                this.isActiveHethongcntt = false;
                this.isActiveLienHe = false;
                this.isActiveCantho = false;
                this.isActiveGiaoDuc = false;
                this.isActiveDanang = false;
                this.isActiveHoChiMinh = false;
                this.isActiveHungYen = false;
                this.isActiveNinhBinh = false;
                this.isActiveBacNinh = false;
                this.isActiveThaiNguyen = true;
            }

            this.activeTab = tab; // Cập nhật giá trị activeTab
            this.showYte = tab === "yte";
            this.showHaiphong = tab === "Haiphong";
            this.showQuangtri = tab === "Quangtri";
            this.showLienHe = tab == "lienhe";
            this.showHethongcntt = tab == "hethongcntt";
            this.showCantho = tab == "cantho";
            this.showGiaoDuc = tab == "giaoduc";
            this.showDanang = tab == "danang";
            this.showHoChiMinh = tab == "HoChiMinh";
            this.showHungYen = tab == "HungYen";
            this.showNinhBinh = tab == "NinhBinh";
            this.showBacNinh = tab == "BacNinh";
            this.showThaiNguyen = tab == "ThaiNguyen";
        },
    },
};
</script>
